import React, { useCallback } from 'react';
import { Clipboard } from 'react-native';
import { Colors, Divider, Flex, IconCopy, Typography } from '@banhala/ui-kit';
import { useGoodsBasic } from '../../../../../queries/useGoodsBasic';
import { bridge } from 'shared/src/utils';

export const InquiryGoodsSkuCode: React.FC = () => {
  const { data } = useGoodsBasic();

  const handleCopy = useCallback(() => {
    if (!data?.sku_code) return;

    Clipboard.setString(data.sku_code);
    bridge.toast('상품 코드를 복사했어요');
  }, [data?.sku_code]);

  if (!data) return null;

  return (
    <>
      <Flex padding={{ horizontal: 16, vertical: 16 }} rowGap={16}>
        <Typography type="body2" color="content_secondary">
          문의 진행 시 상품코드를 알려주시면 더욱 빠른 안내를 받으실 수
          있습니다.
        </Typography>
        <Flex.Row
          alignItems="center"
          justifyContent="space-between"
          backgroundColor="bg_secondary"
          borderRadius={4}
          padding={{ horizontal: 16, vertical: 16 }}
        >
          <Flex.Row alignItems="center" columnGap={12}>
            <Typography type="body2" color="content_secondary">
              상품 코드
            </Typography>
            <Typography type="body2" color="content_primary">
              {data.sku_code}
            </Typography>
          </Flex.Row>
          <Flex.Row alignItems="center" onPress={handleCopy}>
            <IconCopy width={16} height={16} fill={Colors.content_tertiary} />
            <Typography type="body4" color="content_tertiary" marginLeft={2}>
              복사
            </Typography>
          </Flex.Row>
        </Flex.Row>
      </Flex>
      <Divider size="medium" />
    </>
  );
};
